import { createAction } from '@reduxjs/toolkit';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { toast } from 'react-toastify';
import api from '../../utils/api';

export const receiveThreadDetail = createAction('threadDetail/receive');
export const clearThreadDetail = createAction('threadDetail/clear');
export const upvoteThreadDetail = createAction('threadDetail/upvote');
export const downThreadDetail = createAction('threadDetail/downvote');
export const neutralThreadDetail = createAction('threadDetail/neutralvote');
export const addComment = createAction('comment/add');
export const upvoteComment = createAction('comment/upvote');
export const downvoteComment = createAction('comment/downvote');
export const neutralvoteComment = createAction('comment/neutralvote');

export function receiveThreadDetailActionCreator(threadDetail) {
  return receiveThreadDetail({ threadDetail });
}

export function clearThreadDetailActionCreator() {
  return clearThreadDetail();
}

export function upVoteThreadDetailActionCreator(userId) {
  return upvoteThreadDetail({ userId });
}

export function downVoteThreadDetailActionCreator(userId) {
  return downThreadDetail({ userId });
}

export function neutralVoteThreadDetailActionCreator(userId) {
  return neutralThreadDetail({ userId });
}

export function addCommentActionCreator(comment) {
  return addComment({ comment });
}

export function upVoteCommentActionCreator({ commentId, userId }) {
  return upvoteComment({ commentId, userId });
}

export function downVoteCommentActionCreator({ commentId, userId }) {
  return downvoteComment({ commentId, userId });
}

export function neutralVoteCommentActionCreator({ commentId, userId }) {
  return neutralvoteComment({ commentId, userId });
}

export function asyncReceiveThreadDetail(threadId) {
  return async (dispatch) => {
    dispatch(clearThreadDetailActionCreator());
    dispatch(showLoading());
    try {
      const threadDetail = await api.getThreadDetail(threadId);
      dispatch(receiveThreadDetailActionCreator(threadDetail));
    } catch (error) {
      toast.error(error.message);
    }
    dispatch(hideLoading());
  };
}

export function asyncUpVoteThreadDetail(threadId) {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const { userId } = await api.upVoteThread(threadId);
      dispatch(upVoteThreadDetailActionCreator(userId));
    } catch (error) {
      toast.error(error.message);
    }
    dispatch(hideLoading());
  };
}

export function asyncDownVoteThreadDetail(threadId) {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const { userId } = await api.downVoteThread(threadId);
      dispatch(downVoteThreadDetailActionCreator(userId));
    } catch (error) {
      toast.error(error.message);
    }
    dispatch(hideLoading());
  };
}

export function asyncNeutralVoteThreadDetail(threadId) {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const { userId } = await api.neutralVoteThread(threadId);
      dispatch(neutralVoteThreadDetailActionCreator(userId));
    } catch (error) {
      toast.error(error.message);
    }
    dispatch(hideLoading());
  };
}

export function asyncAddComment(threadId, content) {
  return async (dispatch) => {
    let isSuccess;
    dispatch(showLoading());
    try {
      const comment = await api.createComments({ id: threadId, content });
      dispatch(addCommentActionCreator(comment));
      isSuccess = true;
    } catch (error) {
      toast.error(error.message);
      isSuccess = false;
    }
    dispatch(hideLoading());
    return isSuccess;
  };
}

export function asyncUpVoteComment({ threadId, commentId }) {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const { userId } = await api.upVoteComment({ threadId, commentId });
      dispatch(upVoteCommentActionCreator({ commentId, userId }));
    } catch (error) {
      toast.error(error.message);
    }
    dispatch(hideLoading());
  };
}

export function asyncDownVoteComment({ threadId, commentId }) {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const { userId } = await api.downVoteComment({ threadId, commentId });
      dispatch(downVoteCommentActionCreator({ commentId, userId }));
    } catch (error) {
      toast.error(error.message);
    }
    dispatch(hideLoading());
  };
}

export function asyncNeutralVoteComment({ threadId, commentId }) {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const { userId } = await api.neutralVoteComment({ threadId, commentId });
      dispatch(neutralVoteCommentActionCreator({ commentId, userId }));
    } catch (error) {
      toast.error(error.message);
    }
    dispatch(hideLoading());
  };
}
